"use client";
import { jsxs as r, jsx as e } from "react/jsx-runtime";
import { ToastProvider as n, Toast as c, ToastTitle as s, ToastDescription as a, ToastClose as d, ToastViewport as o } from "./toast.js";
import { useToast as l } from "./useToast.js";
import { ExclamationTriangleIcon as m, CheckIcon as p } from "@radix-ui/react-icons";
function x() {
  const { toasts: t } = l();
  return /* @__PURE__ */ r(n, { children: [
    t.map((i, h) => /* @__PURE__ */ r(c, { duration: i.duration, ...i, children: [
      /* @__PURE__ */ e("div", { className: "grid gap-1", children: /* @__PURE__ */ r("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ e("div", { children: i.variant === "destructive" ? /* @__PURE__ */ e(m, { className: "mr-2 h-4 w-4" }) : /* @__PURE__ */ e(p, { className: "mr-1 h-8 w-8" }) }),
        /* @__PURE__ */ r("div", { children: [
          i.title && /* @__PURE__ */ e(s, { children: i.title }),
          i.description && /* @__PURE__ */ e(a, { children: i.description })
        ] })
      ] }) }),
      i.action,
      /* @__PURE__ */ e(d, {})
    ] }, i.id)),
    /* @__PURE__ */ e(
      o,
      {
        variant: t.find((i) => i.variant === "destructive") ? "destructive" : "default"
      }
    )
  ] });
}
export {
  x as Toaster
};
